import apiFetch from '../apiFetch'

export default function (token, dossierSubtypeId, ignoreStoredAndCancelled) {
  return apiFetch({ endPoint: `dossierStage?dossierSubtypeId=${dossierSubtypeId}&ignoreStoredAndCancelled=${ignoreStoredAndCancelled}`, method: 'GET', body: null, token: token })
}
